export default __webpack_public_path__ + "static/03-03-analysis-speedgrade-ai-c655334d4202f4143a328ef0c5faa26e.gif";